module.exports = __webpack_public_path__ + "img/video_views.8e386ea2.svg";